// extracted by mini-css-extract-plugin
export default {"container":"Body_container__TCykS","bodyShapeIcon":"Body_bodyShapeIcon__6jCeD","sheidIcon":"Body_sheidIcon__ooZKn"};